export const textinputMaxLength = 60;
export const textareaMaxLength = 100000;
export const defaultReservedCharacters = '{}*<>';
export const applicationName = 'GRID Webform';
